import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Tab from './PlacesTab';
import Form from './PlaceForm';

function PlacesRouter() {
  return (
    <Switch>
      <Route exact path="/places" component={Tab} />
      <Route exact path="/places/new" component={Form} />
      <Route exact path="/places/:id" component={Form} />
      <Redirect to="/places" />
    </Switch>
  );
}

export default PlacesRouter;



// WEBPACK FOOTER //
// ./src/containers/Places/index.js